<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Senarai Bayaran Deposit">
          <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input 
                            v-model="cari.no_cagaran"
                            label=" No. Akaun Cagaran"
                        />
                    </div>

                    <div class="xs6 mr3">
                        <w-input 
                            v-model="cari.no_rujukan"
                            label=" No. Bayaran"
                        />
                    </div>

                    <div class="xs6 mr3">
                      <w-input 
                            v-model="cari.amaun_deposit"
                            label="Amaun Cagaran (RM)"
                      />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1 " @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <z-table ref="tbluser" title="Senarai Bayaran Deposit" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
              <template #item-cell.amaun="{ item, label, header, index }">
                    <div class="text-right">
                        {{ $zutil.currency(item.amaun) }}
                    </div>
              </template>
              <template #item-cell.alamat="{ item, label, header, index }">
                    <div>
                       <template v-if="item.alamat1"> 
                        {{item.alamat1.toUpperCase()}}, 
                      </template>
                       <template v-if="item.alamat2"> 
                        {{item.alamat2.toUpperCase()}}, 
                      </template>
                       <template v-if="item.alamat3"> 
                        {{item.alamat3.toUpperCase()}}, 
                      </template>
                      <template v-if="item.poskod"> 
                        {{item.poskod.toUpperCase()}},
                      </template> 
                      <template v-if="item.bandar"> 
                        {{item.bandar.toUpperCase()}}, 
                      </template>
                      <template v-if="item.negeri"> 
                        {{item.negeri.toUpperCase()}}
                      </template>
                    </div>
              </template>
                <!-- <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="newrecord()">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template> -->
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                      <inertia-link :href="$route('deposit.show', item.deposit_id)">
                            <w-tooltip top>
                               <template #activator="{ on }">
                                 <w-icon v-on="on" >
                                   fal fa-file
                                 </w-icon>
                               </template>
                               Papar
                             </w-tooltip>
                        </inertia-link>
                  </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_deposit+'deposit_bayaran',
        reload: true,
        form_profil :{},
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Deposit', route: '/deposit' },
            { label: 'Senarai Bayaran Deposit ', route: '/deposit/deposit_bayaran' }
          ],
          cari : {no_rujukan:'', no_fail:'', no_cagaran:'', amaun_deposit:'',},
          }
  },
  methods: {
       
    search() {
      this.$inertia.visit(window.route('deposit_bayaran.index')+'?no_rujukan='+this.cari.no_rujukan+'&no_file='+this.cari.no_file+'&no_cagaran='+this.cari.amaun_deposit+'&amaun='+this.cari.amaun_deposit, {preserveScroll:true})
    },

    reset(){
      this.cari = {no_rujukan:'', no_fail:'', no_cagaran:'', amaun_deposit:'',}
      this.search()
    }   
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    // this.getData();
      this.dialog.width = 900
      this.cari = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
      if(this.cari.no_rujukan == 'undefined'){this.cari.no_rujukan = ''}
      if(this.cari.no_fail == 'undefined'){this.cari.no_fail = ''}
      if(this.cari.no_cagaran == 'undefined'){this.cari.no_cagaran = ''}
      if(this.cari.amaun_deposit == 'undefined'){this.cari.amaun_deposit = ''}
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>